import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted,{
    duration:3000,
    iconPack: 'custom-class',
    fitToScreen: true,
    onComplete: () => {
    }
})

Vue.toasted.register(
    'defaultSuccess',
    payload => !payload.msg ? 'Operação realizada com sucesso!' : payload.msg,
    {type: 'success', icon: 'icon-line-check-circle', text:'SUCESSO!'}
)
Vue.toasted.register(
    'defaultError',
    payload => !payload.msg ? 'Oooops... Erro inesperado!' : payload.msg,
    {type: 'error', icon: 'icon-warning-sign', text:'ERRO!'}
)
Vue.toasted.register(
    'defaultInfo',
    payload => !payload.msg ? 'Página carregada' : payload.msg,
    {type: 'info', icon: 'icon-line-info', text:'OK!'}
)